import React from 'react';
// component

const AdminForm = (props) => {
  return (
    <section className={`AdminForm ${props.className}`}>
      <div className="con admin">
        <div className="wrap-title">
          <h3 className="Adminform-title">{props.title}</h3>
          <p className="btn-cancle" onClick = {props.handleFloatingClick}>취소</p>
        </div>
        
        <form onSubmit = {props.onSubmit}>

          {props.children}
          
        </form>
      </div>
    </section>
  );
}

export default AdminForm;